import React, { Component } from 'react';
import { func, any } from 'prop-types';

import FieldRenderer from './fieldRender';
import styles from './styles';

export default class UTMobileTable extends Component {
  handleTableRender = table => this.props.rowRenderer(table);

  handleCheck = row => this.props.onChange && this.props.onChange(row);

  render() {
    return (
      <div>
        {this.props.tables
          .filter(_table => _table.external_id)
          .map((table, ind) => (
            <div key={`table-${ind + 1}`} style={styles.table}>
              {this.handleTableRender(table).map((row, index) => (
                <FieldRenderer
                  key={`table-${ind + 1}_row-${index + 1}`}
                  onCheck={this.handleCheck}
                  row={row}
                  index={index}
                />
              ))}
            </div>
          ))}
      </div>
    );
    /* eslint-enable react/jsx-key */
  }
}

UTMobileTable.propTypes = {
  tables: any.isRequired, // eslint-disable-line react/forbid-prop-types
  rowRenderer: func.isRequired,
  onChange: func.isRequired
};
